import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../app-config/app-config-service';

/** Add an admin-token header to all REST API calls from Admin portal */
@Injectable()
export class AdminHeaderInterceptor implements HttpInterceptor {
   constructor(private appConfig: AppConfigService) {}

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      let shouldAddHeader: boolean;
      if (req.url.startsWith('/api')) {
         shouldAddHeader = true;
      } else if (req.url === 'assets/app.config.json') {
         shouldAddHeader = false;
      } else {
         const url = new URL(req.url);
         shouldAddHeader = url.host === location.host && url.pathname.startsWith('/api');
      }

      if (shouldAddHeader) {
         const adminToken = this.appConfig.getConfig()?.adminToken;
         if (adminToken) {
            return next.handle(
               req.clone({
                  setHeaders: {
                     // eslint-disable-next-line @typescript-eslint/naming-convention
                     'admin-token': adminToken,
                  },
               })
            );
         }
      }
      return next.handle(req);
   }
}
